export const openInbox = () => console.log('openInbox web') // eslint-disable-line no-console
